// src/auth/ProtectedRoute.tsx
import React from 'react';
// import { useAuth0 } from '@auth0/auth0-react';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { authState } = useOktaAuth();

    // Show loading while authState is being determined
    if (!authState) return <div>Loading...</div>;
    
    return authState.isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

export default ProtectedRoute;
